// import React, { useState, useRef, useContext } from "react";
// import { dailyUsageReport } from "../../services/transactions";
// import { Typography } from "@mui/material";
// import moment from "moment";
// import { toast } from "react-toastify";
// import "jspdf-autotable";
// import { MyContext } from "../ContextApi";
// import LoadingScreen from "../../utils/LoadingScreen";

// export default function DailyUsageReport() {
//   const [usageData, setUsageData] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
//   const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
//   const [manualCount, setManualCount] = useState(0);
//   const [autoCount, setAutoCount] = useState(0);
//   const [batchCount, setBatchCount] = useState(0);
//   // const [partyArray, setPartyArray] = useState(null);
//   const [productCount, setProductCount] = useState(0);
//   const { getDecryptedSessionItem } = useContext(MyContext);
//   const tableRef = useRef(null);

//   const isEverythingUnique = (arr, key, scanResult) => {
//     const uniques = new Set();
//     arr.forEach((item) => {
//       if (item[scanResult] === 0 && item[key] !== null) {
//         uniques.add(item[key]);
//       }
//     });
//     // let myArr = Array.from(uniques);
//     // setPartyArray(myArr);
//     // console.log("Array", myArr);
//     // console.log("unique", uniques);
//     return uniques.size;
//   };

//   // If quantity value is in decimal format
//   // const handleUsageReport = async () => {
//   //   if (new Date(toDate) - new Date(fromDate) < 0) {
//   //     toast.error("To Date must be greater than From Date");
//   //     return;
//   //   }
//   //   setIsLoading(true);
//   //   const response = await dailyUsageReport(fromDate, toDate);

//   //   if (response["status"] === "success") {
//   //     console.log("response?.data===>", response?.data);
//   //     setBatchCount(
//   //       isEverythingUnique(response?.data, "clientCode", "scanResult")
//   //     );
//   //     setIsLoading(false);
//   //     toast.success("Report is fetched");
//   //     setUsageData(response?.data);

//   //     let mCount = 0;
//   //     let aCount = 0;
//   //     let pCount = 0;

//   //     response?.data.forEach((ele) => {
//   //       // console.log("Element", ele);
//   //       // console.log("Remark", ele?.remark);

//   //       if (typeof ele.quantity === "string") {
//   //         if (ele.quantity.substring(0, 1) === ".") {
//   //           ele.quantity = 0 + "." + ele.quantity.substring(1);
//   //           // console.log("ele.quantity===+++", ele.quantity);
//   //         }
//   //         // console.log("ele.BatchNumber", ele?.batch);

//   //         // console.log(
//   //         //   "parseInt(ele.quantity)",
//   //         //   parseFloat(ele.quantity).toFixed(2)
//   //         // );

//   //         pCount = pCount + parseFloat(ele.quantity);
//   //         // console.log("PCount===>", pCount.toFixed(2));
//   //       }

//   //       if (ele["platform"] === "Manual") {
//   //         // console.log("Element", ele);
//   //         // console.log("Remark", ele.remark);
//   //         // console.log("platform", ele.platform);
//   //         // console.log("Batch", ele.batch);
//   //         // console.log("quantity", ele.quantity);
//   //         if (typeof ele.quantity === "string") {
//   //           // mCount = mCount + parseInt(ele.quantity);
//   //           mCount = mCount + parseFloat(ele.quantity);
//   //         }
//   //       } else {
//   //         if (typeof ele.quantity === "string") {
//   //           // aCount = aCount + parseInt(ele.quantity);
//   //           aCount = aCount + parseFloat(ele.quantity);
//   //         }
//   //       }
//   //     });
//   //     console.log("pCount", pCount);
//   //     console.log("mCount", mCount);
//   //     console.log("aCount", aCount);

//   //     setProductCount(pCount);
//   //     setManualCount(mCount);
//   //     setAutoCount(aCount);
//   //   } else {
//   //     toast.error(response["error"]);
//   //     setIsLoading(false);
//   //   }
//   // };

//   // if quantity value is in integer format
//   const handleUsageReport = async () => {
//     if (new Date(toDate) - new Date(fromDate) < 0) {
//       toast.error("To Date must be greater than From Date");
//       return;
//     }
//     setIsLoading(true);
//     const response = await dailyUsageReport(fromDate, toDate);

//     if (response["status"] === "success") {
//       setBatchCount(
//         isEverythingUnique(response?.data, "clientCode", "scanResult")
//       );
//       setIsLoading(false);
//       toast.success("Report is fetched");
//       setUsageData(response?.data);

//       let mCount = 0;
//       let aCount = 0;
//       let pCount = 0;

//       response?.data.forEach((ele) => {
//         if (typeof ele.quantity === "string") {
//           pCount = pCount + parseInt(ele.quantity);
//         }
//         if (ele["platform"] === "Manual") {
//           if (typeof ele.quantity === "string") {
//             mCount = mCount + parseInt(ele.quantity);
//           }
//         } else {
//           if (typeof ele.quantity === "string") {
//             aCount = aCount + parseInt(ele.quantity);
//           }
//         }
//       });
//       setProductCount(pCount);
//       setManualCount(mCount);
//       setAutoCount(aCount);
//     } else {
//       console.log("response", response);
//       toast.error(response["error"]);
//       setIsLoading(false);
//     }
//   };

//   const tableToCSV = () => {
//     let csv_data = [];

//     let rows = document.getElementsByTagName("tr");

//     for (let i = 0; i < rows.length; i++) {
//       let cols = rows[i].querySelectorAll("td,th");
//       let csvrow = [];
//       for (let j = 0; j < cols.length; j++) {
//         csvrow.push(cols[j].innerHTML);
//       }

//       csv_data.push(csvrow.join(","));
//     }

//     csv_data = csv_data.join("\n");

//     let CSVFile = new Blob([csv_data], {
//       type: "text/csv",
//     });

//     let temp_link = document.createElement("a");

//     temp_link.download = `Usage report - ${fromDate} to  ${toDate}.csv`;
//     let url = window.URL.createObjectURL(CSVFile);
//     temp_link.href = url;

//     temp_link.style.display = "none";
//     document.body.appendChild(temp_link);

//     temp_link.click();
//     document.body.removeChild(temp_link);
//   };

//   return (
//     <div
//       style={{
//         textAlign: "center",
//       }}
//     >
//       <div className="container mb-5 mt-1" style={{ width: 700 }}>
//         <Typography
//           variant="h5"
//           style={{ textAlign: "center", marginBottom: 20 }}
//         >
//           {new Date(fromDate).toISOString().split("T")[0].toString() ===
//             new Date().toISOString().split("T")[0].toString() &&
//           new Date(toDate).toISOString().split("T")[0].toString() ===
//             new Date().toISOString().split("T")[0].toString() ? (
//             <>Todays Usage Report</>
//           ) : (
//             <>Usage Report</>
//           )}
//         </Typography>

//         <div
//           className="row"
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           {isLoading && (
//             <LoadingScreen
//               loading={isLoading}
//               message={"Loading report, please wait.."}
//             />
//           )}
//           <div className="col" style={{ display: "flex", gap: "20px" }}>
//             <div style={{ width: "400px" }}>
//               <label style={{ textAlign: "start", paddingRight: "10px" }}>
//                 {" "}
//                 From Date
//               </label>
//               <input
//                 type="date"
//                 defaultValue={moment().format("YYYY-MM-DD")}
//                 onChange={(e) => {
//                   setFromDate(moment(e.target.value).format("YYYY-MM-DD"));
//                 }}
//                 className="form-control"
//               />
//             </div>

//             <div style={{ width: "400px" }}>
//               <label>To Date</label>
//               <input
//                 type="date"
//                 defaultValue={moment().format("YYYY-MM-DD")}
//                 onChange={(e) => {
//                   setToDate(moment(e.target.value).format("YYYY-MM-DD"));
//                 }}
//                 className="form-control"
//               />
//             </div>
//             <div className="col mt-4">
//               <button
//                 className="btn btn-success"
//                 style={{ width: "200px" }}
//                 onClick={handleUsageReport}
//               >
//                 Create Usage Report
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//       <hr />

//       <div
//         style={{
//           marginTop: 30,
//           marginLeft: 100,
//           marginRight: 100,
//           alignItems: "center",
//           textAlign: "center",
//         }}
//       >
//         <div>
//           {usageData?.length > 0 ? (
//             <div>
//               <button className="btn btn-primary" onClick={tableToCSV}>
//                 Download Usage Report
//               </button>
//             </div>
//           ) : (
//             ""
//           )}
//         </div>

//         {usageData?.length > 0 ? (
//           <div>
//             <table
//               className="table table-striped border"
//               style={{
//                 marginTop: 30,
//               }}
//               id="100"
//               ref={tableRef}
//             >
//               <thead>
//                 <tr>
//                   <th>Date</th>
//                   <th>Number of Party</th>
//                   {/* <th>Name of Party</th> */}
//                   <th>Number of Product</th>
//                   <th>Auto Count</th>
//                   <th>Manual Count</th>
//                   {/* <th>Scan Count</th> */}
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>
//                     {moment(fromDate).format("DD-MM-YYYY")} to{" "}
//                     {moment(toDate).format("DD-MM-YYYY")}
//                   </td>
//                   <td>{batchCount}</td>
//                   {/* <td>
//                     {partyArray?.map((ele, index) => {
//                       return (
//                         <ul style={{ listStyleType: "none" }} key={index}>
//                           <li>{ele}</li>
//                         </ul>
//                       );
//                     })}
//                   </td> */}
//                   <td>{productCount}</td>
//                   <td>{autoCount}</td>
//                   <td>{manualCount}</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <p className="font-weight-bold text-danger">
//             Report data not yet available
//           </p>
//         )}
//       </div>
//     </div>
//   );
// }

import React, { useState, useRef, useContext } from "react";
import { dailyUsageReport } from "../../services/transactions";
import { Typography } from "@mui/material";
import moment from "moment";
import { toast } from "react-toastify";
import "jspdf-autotable";
import { MyContext } from "../ContextApi";
import LoadingScreen from "../../utils/LoadingScreen";

export default function DailyUsageReport() {
  const [usageData, setUsageData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
  const [manualCount, setManualCount] = useState(0);
  const [autoCount, setAutoCount] = useState(0);
  const [batchCount, setBatchCount] = useState(0);
  // const [partyArray, setPartyArray] = useState(null);
  const [productCount, setProductCount] = useState(0);
  const { getDecryptedSessionItem } = useContext(MyContext);
  const tableRef = useRef(null);

  const isEverythingUnique = (arr, key, scanResult) => {
    const uniques = new Set();
    arr.forEach((item) => {
      if (item[scanResult] === 0 && item[key] !== null) {
        uniques.add(item[key]);
      }
    });
    // let myArr = Array.from(uniques);
    // setPartyArray(myArr);
    // console.log("Array", myArr);
    // console.log("unique", uniques);
    return uniques.size;
  };

  // If quantity value is in decimal format
  // const handleUsageReport = async () => {
  //   if (new Date(toDate) - new Date(fromDate) < 0) {
  //     toast.error("To Date must be greater than From Date");
  //     return;
  //   }
  //   setIsLoading(true);
  //   const response = await dailyUsageReport(fromDate, toDate);

  //   if (response["status"] === "success") {
  //     console.log("response?.data===>", response?.data);
  //     setBatchCount(
  //       isEverythingUnique(response?.data, "clientCode", "scanResult")
  //     );
  //     setIsLoading(false);
  //     toast.success("Report is fetched");
  //     setUsageData(response?.data);

  //     let mCount = 0;
  //     let aCount = 0;
  //     let pCount = 0;

  //     response?.data.forEach((ele) => {
  //       // console.log("Element", ele);
  //       // console.log("Remark", ele?.remark);

  //       if (typeof ele.quantity === "string") {
  //         if (ele.quantity.substring(0, 1) === ".") {
  //           ele.quantity = 0 + "." + ele.quantity.substring(1);
  //           // console.log("ele.quantity===+++", ele.quantity);
  //         }
  //         // console.log("ele.BatchNumber", ele?.batch);

  //         // console.log(
  //         //   "parseInt(ele.quantity)",
  //         //   parseFloat(ele.quantity).toFixed(2)
  //         // );

  //         pCount = pCount + parseFloat(ele.quantity);
  //         // console.log("PCount===>", pCount.toFixed(2));
  //       }

  //       if (ele["platform"] === "Manual") {
  //         // console.log("Element", ele);
  //         // console.log("Remark", ele.remark);
  //         // console.log("platform", ele.platform);
  //         // console.log("Batch", ele.batch);
  //         // console.log("quantity", ele.quantity);
  //         if (typeof ele.quantity === "string") {
  //           // mCount = mCount + parseInt(ele.quantity);
  //           mCount = mCount + parseFloat(ele.quantity);
  //         }
  //       } else {
  //         if (typeof ele.quantity === "string") {
  //           // aCount = aCount + parseInt(ele.quantity);
  //           aCount = aCount + parseFloat(ele.quantity);
  //         }
  //       }
  //     });
  //     console.log("pCount", pCount);
  //     console.log("mCount", mCount);
  //     console.log("aCount", aCount);

  //     setProductCount(pCount);
  //     setManualCount(mCount);
  //     setAutoCount(aCount);
  //   } else {
  //     toast.error(response["error"]);
  //     setIsLoading(false);
  //   }
  // };

  // if quantity value is in integer format
  const handleUsageReport = async () => {
    if (new Date(toDate) - new Date(fromDate) < 0) {
      toast.error("To Date must be greater than From Date");
      return;
    }
    setIsLoading(true);
    const response = await dailyUsageReport(fromDate, toDate);

    if (response["status"] === "success") {
      setBatchCount(
        isEverythingUnique(response?.data, "clientCode", "scanResult")
      );
      setIsLoading(false);
      toast.success("Report is fetched");
      setUsageData(response?.data);

      let mCount = 0;
      let aCount = 0;
      let pCount = 0;

      response?.data.forEach((ele) => {
        if (typeof ele.quantity === "string") {
          pCount = pCount + parseInt(ele.quantity);
        }
        if (ele["platform"] === "Manual") {
          if (typeof ele.quantity === "string") {
            mCount = mCount + parseInt(ele.quantity);
          }
        } else {
          if (typeof ele.quantity === "string") {
            aCount = aCount + parseInt(ele.quantity);
          }
        }
      });
      setProductCount(pCount);
      setManualCount(mCount);
      setAutoCount(aCount);
    } else {
      console.log("response", response);
      toast.error(response["error"]);
      setIsLoading(false);
    }
  };

  const tableToCSV = () => {
    if (!tableRef.current) return;

    let csv_data = [];
    let rows = tableRef.current.querySelectorAll("tr");

    rows.forEach((row) => {
      let cols = row.querySelectorAll("td, th");
      let csvrow = [];

      cols.forEach((col) => {
        let text = col.innerText.replace(/(\r\n|\n|\r)/gm, "").trim();

        text = `"${text.replace(/"/g, '""')}"`;

        csvrow.push(text);
      });

      csv_data.push(csvrow.join(","));
    });

    csv_data = csv_data.join("\n");

    let CSVFile = new Blob([csv_data], { type: "text/csv;charset=utf-8;" });

    let temp_link = document.createElement("a");
    temp_link.download = `Usage_Report_${fromDate}_to_${toDate}.csv`;
    temp_link.href = window.URL.createObjectURL(CSVFile);

    document.body.appendChild(temp_link);

    temp_link.click();
    document.body.removeChild(temp_link);
  };

  return (
    <div
      style={{
        textAlign: "center",
      }}
    >
      <div className="container mb-5 mt-1" style={{ width: 700 }}>
        <Typography
          variant="h5"
          style={{ textAlign: "center", marginBottom: 20 }}
        >
          {new Date(fromDate).toISOString().split("T")[0].toString() ===
            new Date().toISOString().split("T")[0].toString() &&
            new Date(toDate).toISOString().split("T")[0].toString() ===
            new Date().toISOString().split("T")[0].toString() ? (
            <>Todays Usage Report</>
          ) : (
            <>Usage Report</>
          )}
        </Typography>

        <div
          className="row"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {isLoading && (
            <LoadingScreen
              loading={isLoading}
              message={"Loading report, please wait.."}
            />
          )}

          <div className="col" style={{ display: "flex", gap: "20px" }}>
            <div style={{ width: "400px" }}>
              <label style={{ textAlign: "start", paddingRight: "10px" }}>
                From Date
              </label>
              <input
                type="date"
                defaultValue={moment().format("YYYY-MM-DD")}
                onChange={(e) => {
                  setFromDate(moment(e.target.value).format("YYYY-MM-DD"));
                }}
                className="form-control"
              />
            </div>

            <div style={{ width: "400px" }}>
              <label>To Date</label>
              <input
                type="date"
                defaultValue={moment().format("YYYY-MM-DD")}
                onChange={(e) => {
                  setToDate(moment(e.target.value).format("YYYY-MM-DD"));
                }}
                className="form-control"
              />
            </div>

            <div className="col mt-4">
              <button
                className="btn btn-success"
                style={{ width: "200px" }}
                onClick={handleUsageReport}
              >
                Create Usage Report
              </button>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div
        style={{
          marginTop: 30,
          marginLeft: 100,
          marginRight: 100,
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div>
          {usageData?.length > 0 ? (
            <div>
              <button className="btn btn-primary" onClick={tableToCSV}>
                Download Usage Report
              </button>
            </div>
          ) : (
            ""
          )}
        </div>

        {usageData?.length > 0 ? (
          <div>
            <table
              className="table table-striped border"
              style={{ marginTop: 30 }}
              id="100"
              ref={tableRef}
            >
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Client Name</th>
                  <th>Region</th>
                  <th>Remark</th>
                  <th>Total Lines Items</th>
                  <th>Total Quantity</th>
                  {/* <th>Total Value</th> */}
                </tr>
              </thead>

              <tbody>
                {[...usageData]
                  .sort((a, b) => {
                    // 1️⃣ Sort by Date (Ascending)
                    const dateA = a.Date ? new Date(a.Date) : new Date(0);
                    const dateB = b.Date ? new Date(b.Date) : new Date(0);

                    const dateDiff = dateA - dateB;
                    if (dateDiff !== 0) return dateDiff;

                    // 2️⃣ Safe Client Name sorting (null-safe)
                    const nameA = (a.clientName || "").toString().toLowerCase();
                    const nameB = (b.clientName || "").toString().toLowerCase();

                    return nameA.localeCompare(nameB);
                  })
                  .map((row, index) => (
                    <tr key={index}>
                      <td>{moment(row.Date).format("DD-MM-YYYY")}</td>
                      <td>{row.clientName || "-"}</td>
                      <td>{row.region}</td>
                      <td>{row.Remark === "nan" ? "-" : row.Remark}</td>
                      <td>{row.Total_Lines}</td>
                      <td>{row.Total_Qty}</td>
                      {/* <td>{Number(row.Total_Value_CN).toFixed(2)}</td> */}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="font-weight-bold text-danger">
            Report data not yet available
          </p>
        )}
      </div>
    </div>
  );
}
